export type TakeoverActionMode = 'fleet' | 'takeover' | 'disabled' | 'hidden';
export type TakeoverTooltipKey = 'errors.calculation.takeover.notSubmittedAndApproved';
export interface TakeoverAction {
  mode: TakeoverActionMode;
  tooltipKey?: TakeoverTooltipKey;
}

export function resolveTakeoverAction(
  row: { isSubmittedAndApproved?: boolean; isPrimaryCalculation?: boolean },
  isFleetDeal: boolean,
  canExecute: boolean
): TakeoverAction {
  const isActiveContract = row.isPrimaryCalculation;
  if (!isActiveContract || !canExecute) return { mode: 'hidden' };
  if (!row.isSubmittedAndApproved) {
    return { mode: 'disabled', tooltipKey: 'errors.calculation.takeover.notSubmittedAndApproved' };
  }
  return { mode: isFleetDeal ? 'fleet' : 'takeover' };
}
